import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { NationalTransferMutableAttributes } from "../../domain/models/NationalTransfer";
import { nationalTransferMutationService } from "../../services/payments/NationalTransferMutationService";
type UpdateNationalTransferInput = {
  id: string;
  attributes: NationalTransferMutableAttributes;
};
export function useUpdateNationalTransfer() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["payments", "national-transfers"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
function _temp(t0) {
  const {
    id,
    attributes
  } = t0;
  return nationalTransferMutationService.update(id, attributes);
}